import './footer.css';
import TSGPoweredLogo from '../../assets/TSG-Powered-Logo.svg';
import type { RemoteConfiguration } from '@thesavingsgroup/remote-configuration/types/RemoteConfiguration';

const Footer = ({ configuration }: { configuration: RemoteConfiguration }) => {
  const { displayFooterLogo } = configuration;

  return (
    <footer>
      {displayFooterLogo && (
        <img src={TSGPoweredLogo} alt="Powered by The Savings Group logo" />
      )}
    </footer>
  );
};

export default Footer;
